<template>
    <v-app id="us-join-company">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goHome">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">转让管理权确认</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content style="padding-top:1rem;">
            <v-container style="margin-top:5.5rem;">
                <div style="text-align:center;">
                  <!-- <i style="font-size:10rem;color:#03A9F4;" class="fa fa-share-alt-square" aria-hidden="true" /> -->
                  <img width="160" height="160" src="/res/favicon.png"/>
                </div>
                <div style="text-align:center;margin-top:1rem;font-weight: bold;">
                  <div v-if="inivteState === 400 || inivteState === 401" style="color:#F56C6C;">
                      二维码无效.
                  </div>
                  <div v-else-if="inivteState === 402" style="color:#606266;">
                      二维码过期了.
                  </div>
                  <div v-else-if="inivteState === 403" style="color:#606266;">
                      您已经是管理员了.
                  </div>
                  <div v-else-if="inivteState === 200">
                    <div style="color:#606266;">
                      【{{companyInfo.COMPANY_NAME}}】 企业管理权转让给您.
                    </div>
                    <div style="margin:auto;margin-top:1rem;text-align:center;">
                      <!-- <div><v-btn large color="success" style="width:60%;font-weight:bold;font-size:0.96rem;" @click="submit" :disabled="btnDisabled" >接受</v-btn></div>
                      <div><v-btn large color="#f2f2f2" style="width:60%;margin-top:2rem;font-weight:bold;font-size:0.96rem;" @click="rejectTransfer" :disabled="btnDisabled" >拒绝</v-btn></div> -->
                      <div>
                        <v-btn large class="secondary us-btn-style" @click="submit" :disabled="btnDisabled" >接受</v-btn>
                      </div>
                      <div>
                        <v-btn large color="error" class="us-btn-style" @click="rejectTransfer" :disabled="btnDisabled" >拒绝</v-btn>
                      </div>
                    </div>
                  </div>
                  <div v-else style="color:#606266;">[{{inivteState}}]</div>
                  <div v-if="inivteState !== 200" class="text-center">
                    <v-btn
                      color="blue-grey"
                      class="white--text us-btn-style"
                      large
                      @click="goHome"
                    >
                      返回主页
                    </v-btn>
                  </div>
                </div>
            </v-container>
        </v-content>
    </v-app>

</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      companyInfo: {},
      btnDisabled: false,
      inivteState: 0,
      strRes: '',
      shareRecord: {},
      companyCode: '',
      shareCode: ''
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.companyCode = that.$route.query.company_code
    that.shareCode = that.$route.query.share_code
    that.getShareRecord()
  },
  created() {
  },
  methods: {
    goHome() {
      var that = this;
      that.$router.replace('/Home')
    },
    getShareRecord() {
      var that = this
      if (!that.shareCode || that.shareCode === '') {
        that.inivteState = 400
        return
      }

      that.$api.bz.getShareRecord({ code: that.shareCode }).then(res => {
        that.strRes = JSON.stringify(res)
        // console.log('getShareRecord.res', res);
        if (!res.success) {
          that.getformatState(res.error_msg)
          return
        }
        that.shareRecord = res.data
        that.getCompanyInfo();
      })
    },
    submit() {
      var that = this
      that.$api.bz.tranCompanyConfirm({ code: that.companyInfo.COMPANY_CODE }).then(res => {
        if (!res.success) {
          that.$toast.warning('确认失败');
          return
        }
        that.btnDisabled = true
        // that.$toast.success('确认成功');
        // setTimeout(function() {
        //   that.goHome()
        // }, 1500);
        that.$router.goActionResPage({ tag: 1, text: '确认成功', auto_ret: 'a' })
      })
    },
    getformatState(errMsg) {
      var that = this
      var errCode = errMsg.substr(1, 3)
      if (errCode === '401') {
        that.inivteState = 401
      } else if (errCode === '402') {
        that.inivteState = 402
      } else if (errCode === '403') {
        that.inivteState = 403
      } else {
        that.inivteState = 400
      }
    },
    rejectTransfer() {
      var that = this
      that.btnDisabled = true
      that.$router.goActionResPage({ tag: 0, text: '已拒绝', auto_ret: 'a' })
    },
    // 获取企业信息
    async getCompanyInfo() {
      var that = this
      if (!that.companyCode) {
        return;
      }
      await that.$api.bz.getCompanyInfo({ code: that.companyCode }).then(res => {
        console.log('getCompanyInfo.res', res);
        if (!res.success) {
          // that.$toast.warning('获取企业信息失败');
          console.log('获取企业信息失败', res)
          return
        }
        that.companyInfo = res.data
        var userInfo = that.$AppHelper.getCustomData('user_info');
        if (that.companyInfo.COMPANY_ADMIN_CODE === userInfo.usercode) {
          that.inivteState = 403
        } else {
          that.inivteState = 200
        }
      })
    }
  }
}
</script>

<style scoped>
.secondary {
    background-color: #5cbbf6 !important;
    border-color: #5cbbf6 !important;
}
.us-btn-style {
  font-size: 16px;
  width: 90%;
  font-weight: bold;
  margin-top: 1.1rem;
  text-align: center;
}
</style>
